import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Sofía', 'Lucía', 'Martín', 'Florencia', 'Camila', 'Agustina', 'Valentina', 'Carolina', 'Mariana'];
const CITIES = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Bahía Blanca', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0,
    avatarId: 1
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      const randomAvatar = Math.floor(Math.random() * 70) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime,
        avatarId: randomAvatar
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Interval for subsequent popups (every 20-30 seconds)
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 10000) + 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-158">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-brand-card border border-brand-mint/20 rounded-xl shadow-2xl p-4 flex items-center gap-3 pr-8" data-id="element-159">
          <div className="flex-shrink-0 w-10 h-10 bg-green-500/15 border border-green-500/40 rounded-full flex items-center justify-center" data-id="element-160">
            <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-161" />
          </div>
          <div data-id="element-162">
            <p className="text-sm text-brand-cream font-medium" data-id="element-163">
              <span className="font-bold" data-id="element-164">{data.name}</span> de {data.city}
            </p>
            <p className="text-xs text-brand-mint mt-0.5" data-id="element-165">
              Compró este libro digital hace {data.time} min
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}